function isAndroid() {
    return "android" in window;
}
function isIOS() {
    return "webkit" in window;
}
export function isMobile() {
    return isAndroid() || isIOS();
}
